<template>
    <SubLayout
        :pageTitle="title"
        :pageBreadcrumbs="breadcrumbs"
        :hasBack="true"
    >
        <template #layoutContent>
            <Loader :isLoading="isReady">
                <div class="card card-flush h-lg-100 bg-transparent p-0 m-0" id="kt_content">
                    <div class="card-body p-0 m-0">
                        <div class="h-100 d-flex align-items-stretch flex-column mx-lg-15">
                            <ul class="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x fs-4 border-0 bg-white rounded-1 shadow p-3 fw-bold mb-n2">
                                <li class="nav-item" v-if="$can(abilities.CREATE_PRODUCT)">
                                    <a class="nav-link text-active-primary pb-4 active" data-bs-toggle="tab"
                                    href="#kt_ecommerce_add_product_general">{{ $t('products.general') }}</a>
                                </li>
                                <li class="nav-item" v-if="$can(abilities.UPDATE_PRODUCT)">
                                    <a v-if="$route.query.product" class="nav-link text-active-primary pb-4" data-bs-toggle="tab"
                                    href="#kt_ecommerce_add_product_advanced">{{ $t('products.variation') }}</a>
                                </li>
                            </ul>

                            <div class="tab-content mt-5 mb-10">
                                <div class="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div class="form d-flex flex-column flex-lg-row">
                                    <div class="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                                        <div class="card card-flush py-4">
                                        <div class="card-header">
                                            <div class="card-title">
                                            <h2>{{ $t('products.general') }}</h2>
                                            </div>
                                            <div class="card-toolbar">
                                            <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_PRODUCT)" type="new" btn-text="button.save" @click.prevent="createProductData" :isLoading="isLoading1"/>
                                            </div>
                                        </div>

                                        <div class="card-body pt-0">
                                            <RequiredText />
                                            <div class="row mt-5">
                                                <div class="col-md-6 col-sm-12 order-0 order-md-1">
                                                    <div class="row">
                                                        <div class="text-center">
                                                            <div style=" text-align:center">
                                                                <ImageInput class="" v-model:image="formCreateData.image" :model-image="formCreateData.image" containerClass="mb-10 text-center" imageClass="rounded-circle"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-sm-12 order-1 order-md-0">
                                                    <div class="row">
                                                    <div class="col-12">
                                                        <label class="required form-label">{{ $t('products.type') }}</label>
                                                        <div class="input-group input-group-solid flex-nowrap">
                                                        <div class="overflow-hidden flex-grow-1">
                                                            <select class="form-select form-select-solid kt_select2 mb-5" required name="type" v-model="formCreateData.type"
                                                                    data-control="select2" data-search="true"
                                                                    :data-placeholder="$t('products.select_type')">
                                                                    <option v-for="(type, index) in getTypes" :key="index" :value="type.value">{{ this.$i18n.locale == 'fr' ? type.fr : type.en}}</option>
                                                            </select>
                                                        </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12">
                                                        <label class="required form-label">{{ $t('products.designation') }}</label>
                                                        <input type="text" v-model="formCreateData.name" :placeholder="$t('products.placeholder_designation')" required
                                                            class="form-control form-control-solid" />

                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-5">
                                            <div class="col-md-6 col-sm-12">
                                                <label class="required form-label">{{ $t('products.reference') }}</label>
                                                <input type="text" v-model="formCreateData.reference" class="form-control-solid form-control mb-2"
                                                        :placeholder="$t('products.placeholder_reference')" required />

                                            </div>

                                            <div class="col-md-6 col-sm-12">
                                                <label class="required form-label">{{ $t('products.category') }}</label>
                                                <div class="input-group input-group-solid flex-nowrap">
                                                <div class="overflow-hidden flex-grow-1">
                                                    <select name="category" required class="form-select form-select-solid kt_select2"
                                                            v-model="formCreateData.category" data-control="select2" data-search="true"
                                                            :data-placeholder="$t('products.select_category')">
                                                    <option v-for="category in getCategories" :key="category.id" :value="category.id">
                                                        {{  category.name }}
                                                    </option>
                                                    </select>
                                                </div>
                                                <span v-if="$can(abilities.CREATE_CATEGORY)" data-bs-toggle="modal" data-bs-target="#createCategoryModal"
                                                        class="input-group-text">
                                                        <span class="svg-icon svg-icon-2 px-1 py-3 text-center" :style="{'border': '1px solid '+$getCssVariable('--bs-primary'), 'border-radius': '5px', 'background-color': '#fff', 'width': '30px !important', 'height': '30px !important'}">
                                                            <i class="fas fa-plus text-primary" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                                        </span>
                                                </span>
                                                </div>

                                            </div>

                                            <div class="col-md-6 col-sm-12 mt-5">
                                                <label class="required form-label">{{ $t('products.purchase_price') }} ({{ getCompanyCurrency?.symbol }})</label>

                                                <VueNumberFormat class="form-control form-control-solid" required  v-model:value="formCreateData.purchase_price"   :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                                                ></VueNumberFormat>
                                            </div>

                                            <div class="col-md-6 col-sm-12 mt-5">
                                                <label class="required form-label">{{ $t('products.selling_price') }} ({{ getCompanyCurrency?.symbol }})</label>

                                                <VueNumberFormat class="form-control form-control-solid" required  v-model:value="formCreateData.selling_price"   :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                                                ></VueNumberFormat>
                                            </div>

                                            <div class="col-md-6 col-sm-12 mt-5" v-if="formCreateData.type === 'PRODUCT'">
                                                <label class=" form-label">{{ $t('products.brand') }}</label>
                                                <div class="input-group input-group-solid flex-nowrap">
                                                <div class="overflow-hidden flex-grow-1">
                                                    <select class="form-select form-select-solid kt_select2 " name="brand" v-model="formCreateData.brand"
                                                            data-control="select2" data-search="true"
                                                            data-allow-clear="true"
                                                            :data-placeholder="$t('products.select_brand')">

                                                    <option v-for="brand in getBrands" :key="brand.id" :value="brand.id">{{ brand.name }}</option>

                                                    </select>
                                                </div>
                                                <span v-if="$can(abilities.CREATE_BRAND)" data-bs-toggle="modal" data-bs-target="#createBrandModal_create"
                                                        class="input-group-text">
                                                        <span class="svg-icon svg-icon-2 px-1 py-3 text-center" :style="{'border': '1px solid '+$getCssVariable('--bs-primary'), 'border-radius': '5px', 'background-color': '#fff', 'width': '30px !important', 'height': '30px !important'}">
                                                            <i class="fas fa-plus text-primary" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                                        </span>
                                                </span>
                                                </div>
                                            </div>

                                            <div class="col-md-6 col-sm-12 mt-5" v-if="product.sale_element_with_attributes?.length === 1">
                                                <label class=" form-label">{{ $t('products.barcode') }}</label>

                                                <input
                                                type="text"
                                                v-model="formCreateData.barcode"
                                                class="form-control-solid form-control mb-2"
                                                :data-placeholder="$t('products.barcode')"
                                                />
                                            </div>
                                            <div class="col-md-6 col-sm-12 mt-5" v-if="formUpdateVariation.length <= 0">
                                                <label class=" form-label">{{ $t('products.barcode') }}</label>

                                                <input
                                                    type="text"
                                                    v-model="formCreateData.barcode"
                                                    class="form-control-solid form-control mb-2"
                                                    :placeholder="$t('products.barcode')"

                                                />
                                            </div>
                                            </div>

                                            <div class="mb-5">
                                                <label class=" form-label">{{ $t('products.taxes') }}</label>
                                                <div class="input-group input-group-solid flex-nowrap">
                                                    <div class="overflow-hidden flex-grow-1">
                                                    <select  name="taxes[]"  class="form-select form-select-solid kt_select2" multiple="multiple"
                                                            v-model="formCreateData.taxes" data-control="select2" data-search="true"
                                                            :data-placeholder="$t('products.select_taxes')">
                                                        <option v-for="(tax, index) in getTaxes" :key="index" :value="tax.id">
                                                        {{ tax.title }}
                                                        {{
                                                            tax.type === 'percent'
                                                                ? `(${tax.amount}%)`
                                                                : `(${tax.amount} ${getCompanyCurrency?.iso})`
                                                        }}
                                                        </option>
                                                    </select>
                                                    </div>
                                                    <span v-if="$can(abilities.CREATE_TAX)" data-bs-toggle="modal" data-bs-target="#createTaxModal"
                                                        class="input-group-text">
                                                        <span class="svg-icon svg-icon-2 px-1 py-3 text-center" :style="{'border': '1px solid '+$getCssVariable('--bs-primary'), 'border-radius': '5px', 'background-color': '#fff', 'width': '30px !important', 'height': '30px !important'}">
                                                            <i class="fas fa-plus text-primary" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                                        </span>
                                                    </span>
                                                </div>
                                                </div>
                                            <div>
                                            <label class="form-label">{{ $t('products.description') }}</label>
                                            <textarea name="textarea_input" v-model="formCreateData.description"
                                                        class="form-control form-control-solid"></textarea>
                                            </div>

                                            <br><br>

                                            <div class="py-2" v-if="!formCreateData.product">
                                                <div class="card-title">
                                                    <h2 class="text-primary">{{ $t('products.create_variation') }}</h2>
                                                </div>
                                                <div data-kt-ecommerce-catalog-add-product="auto-options">
                                                    <div id="kt_ecommerce_add_product_options">
                                                        <div class="row mt-5" v-for="(content, key) in formCreateData.attributs" :key="key">
                                                            <div class="col-md-4 col-sm-12">
                                                                <label class="form-label">{{ $t('products.attribut') }}</label>
                                                                <div class="input-group input-group-solid flex-nowrap">
                                                                    <div class="overflow-hidden flex-grow-1">
                                                                        <select :data-key="key" class="form-select form-select-solid rounded-end-0 kt_select2"
                                                                                data-control="select2" data-search="true" v-model="content.attribut_id"
                                                                                name="attributs" :data-placeholder="$t('products.select_attribut')"
                                                                                data-allow-clear="true">
                                                                            <option v-for="attribut in getFilteredAttribute(key)" :key="attribut.id"
                                                                                    :value="attribut.id">{{ attribut.name }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <span v-if="$can(abilities.CREATE_ATTRIBUT)" @click="openVariationModal(false, key)"
                                                                        class="input-group-text">
                                                                        <span class="svg-icon svg-icon-2 px-1 py-3 text-center" :style="{'border': '1px solid '+$getCssVariable('--bs-primary'), 'border-radius': '5px', 'background-color': '#fff', 'width': '30px !important', 'height': '30px !important'}">
                                                                            <i class="fas fa-plus text-primary" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            <div class="col-md-7 col-sm-12">
                                                                <label class="form-label"> {{ $t('products.values') }}</label>
                                                                <div class="input-group input-group-solid flex-nowrap">
                                                                    <div class="overflow-hidden flex-grow-1">
                                                                        <select :data-key="key" class="form-select form-select-solid kt_select2"
                                                                                data-control="select2" multiple="multiple" name="variations[]" data-search="true"
                                                                                v-model="content.variations">
                                                                            <option v-for="value in getAttributeVariations(content.attribut_id)" :key="value.id"
                                                                                    :value="value.id">{{ value.name }}
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                    <span v-if="content.attribut_id" @click.prevent="addVariationAttributeModalOpen(false, content.attribut_id, key)"
                                                                        class="input-group-text">
                                                                        <span class="svg-icon svg-icon-2 px-1 py-3 text-center" :style="{'border': '1px solid '+$getCssVariable('--bs-primary'), 'border-radius': '5px', 'background-color': '#fff', 'width': '30px !important', 'height': '30px !important'}">
                                                                            <i class="fas fa-plus text-primary" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                                                        </span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-1 col-sm-12" style="float: right;">
                                                                <div class="card shadow-sm mt-8 py-2 px-4" style="height: 40px; width: 50px;">
                                                                    <div class="d-flex justify-content-center py-2 text-center" @click.prevent="drop(key)" style="border: 1px solid red; border-radius: 8px; background-color: #fff; width: 30px !important; height: 30px !important;">
                                                                        <i class="fa fa-trash-alt fs-2" style="color: red"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="form-group mt-5 text-end">
                                                            <button @click.prevent="add" type="button" class="btn btn-sm btn-light-primary" style="border-radius: 5px">
                                                                {{ $t('products.add_attribut') }}
                                                                <span class="svg-icon svg-icon-2 p-1 text-center ms-1" style="border: 1px solid #fff; border-radius: 5px; background-color: #fff;">
                                                                    <i class="fas fa-plus text-primary ms-1" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                                                </span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                            <div class="d-flex justify-content-end mt-10">
                                                <Button btn-class="btn-sm" v-if="$can(abilities.CREATE_PRODUCT)" type="new" btn-text="button.save" @click.prevent="createProductData" :isLoading="isLoading1"/>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="kt_ecommerce_add_product_advanced" role="tab-panel">
                                    <div class="d-flex flex-column gap-7 gap-lg-10">
                                    <div class="card card-flush py-4">
                                        <!--begin::Card header-->
                                        <div class="card-header">
                                        <div class="card-title">
                                            <h2>{{ $t('products.list_variation') }}</h2>
                                        </div>
                                        <div class="card-toolbar" >
                                            <Button btn-class="btn-sm me-2" v-if="showMultipleDeleteBtn && $can(abilities.UPDATE_PRODUCT)" type="cancel" btn-text="products.delete_variation" @click.prevent="deleteProductSaleElementsAction" :isLoading="deletedLoading"/>
                                            <Button btn-class="btn-sm me-2" v-if="formCreateData.product && $can(abilities.UPDATE_PRODUCT)" type="new" btn-text="products.add_variation" @click.prevent="openCreateVariationModal"/>
                                            <Button btn-class="btn-sm" v-if="isVariationProduct && product?.sale_element_with_attributes?.length && $can(abilities.UPDATE_PRODUCT)" type="new" btn-text="button.save" @click.prevent="updateProductSaleElementsAction" :isLoading="loading"/>
                                        </div>
                                        </div>

                                        <div class="card-body pt-0">
                                        <div class="table-responsive">
                                            <table class="table align-middle table-row-dashed fs-6 fw-bold gy-4" id="datatable_variation">
                                            <!--begin::Table head-->
                                            <thead>
                                            <tr class="text-start text-muted fw-bolder fs-7 text-uppercase gs-0">
                                                <th class="ps-2 col-1">
                                                <div class="form-check form-check-sm form-check-custom form-check-solid mt-3">
                                                    <input name="variation_all_checkbox" id="variation_all_checkbox" class=" form-check-input" type="checkbox" />
                                                </div>
                                                </th>
                                                <th class="col-5">{{ $t('products.variation') }}</th>
                                                <th class="col-2 text-center">{{ $t('products.purchase_price') }} ({{ getCompanyCurrency?.iso }})</th>
                                                <th class="col-2 text-center">{{ $t('products.selling_price') }} ({{ getCompanyCurrency?.iso }})</th>
                                                <th class="col-2 text-center">{{ $t('products.barcode') }}</th>
                                                <th class="col-1">{{ $t('actions') }}</th>
                                            </tr>
                                            </thead>
                                            <tbody class="text-gray-600" v-if="isVariationProduct">
                                                <tr v-for="(combinaison,index) in product.sale_element_with_attributes" :key="index">
                                                    <td class="col-1 ps-2">
                                                    <div class="form-check form-check-sm form-check-custom form-check-solid mt-3">
                                                        <input name="variation_checkbox" class="variation_checkbox form-check-input" type="checkbox" :value="combinaison.id" />
                                                    </div>
                                                    </td>
                                                    <td class="col-5">
                                                        <span v-for=" attribut in combinaison.attributeAndCombination" :key="attribut.name">
                                                                {{ attribut.name + " " }}<br>
                                                        </span>
                                                    </td>
                                                    <td class="col-2">
                                                        <VueNumberFormat class="form-control form-control-solid" required  v-model:value="formUpdateVariation[index].purchase_price" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                                                        ></VueNumberFormat>
                                                    </td>
                                                    <td class="col-2">
                                                        <VueNumberFormat class="form-control form-control-solid" required  v-model:value="formUpdateVariation[index].selling_price" :options="{ precision: 0, prefix: '', acceptNegative: false, isInteger: false  }"
                                                        ></VueNumberFormat>
                                                    </td>
                                                    <td class="col-2"><input style="width: 175px!important;" class="form-control form-control-solid" type="text" min="0"
                                                                            v-model="formUpdateVariation[index].barcode" /></td>
                                                    <td class="col-1 text-end">
                                                    <a href="#" v-if="$can(abilities.UPDATE_PRODUCT)" @click.prevent="deleteProductSaleElementAction(combinaison.id, product.id)"
                                                        class="btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3"
                                                        :title="$t('button.delete')" data-kt-action="product_remove">
                                                        <i class="fa fa-trash-alt"></i>
                                                    </a>
                                                    </td>
                                                </tr>
                                            </tbody>

                                            <tbody class="text-gray-600 justify-content-center" v-else>
                                                <tr>
                                                    <td colspan="6">
                                                        <div class="text-center" >
                                                        <img src="@/assets/media/pos/Empty1.png" alt="" class="mw-80 h-150px" />
                                                        <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found')}}</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                        </div>
                                        <div class="card-footer">
                                        <div class="d-flex justify-content-end">
                                            <Button btn-class="btn-sm" v-if="isVariationProduct && product?.sale_element_with_attributes?.length && $can(abilities.UPDATE_PRODUCT)" type="new" btn-text="button.save" @click.prevent="updateProductSaleElementsAction" :isLoading="loading"/>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal fade" id="kt_modal_create_variation" data-backdrop="static" tabindex="-1" role="dialog"
                        aria-labelledby="staticBackdrop" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{ $t('products.create_variation') }}</h5>
                                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                                <span class="svg-icon svg-icon-1">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                            fill="currentColor" />
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                            fill="currentColor" />
                                    </svg>
                                </span>
                                </div>
                            </div>

                            <div class="modal-body">
                                <RequiredText />
                                <form id="kt_modal_new_target_form" @submit.prevent="createProductVariationsData" class="form">
                                <div id="kt_ecommerce_add_product_option">
                                    <div class="row mt-2">
                                    <div class="alert alert-dismissible bg-light-primary d-flex flex-column flex-sm-row p-1 mb-2">
                                        <i class="ki-duotone ki-notification-bing fs-2hx text-primary me-4 mb-5 mb-sm-0"><span class="path1"></span><span class="path2"></span><span class="path3"></span></i>
                                        <div class="d-flex flex-column pe-0 pe-sm-10">
                                        <h4 class="fw-semibold"></h4>
                                        <span>{{$t('products.add_variation_helper')}}</span>
                                        </div>
                                        <button type="button" class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto" data-bs-dismiss="alert">
                                        <i class="ki-duotone ki-cross fs-1 text-primary"><span class="path1"></span><span class="path2"></span></i>
                                        </button>
                                    </div>
                                    </div>
                                    <div class="row mt-5" v-for="(content, key) in formCreateData.attributs" :key="key">
                                    <div class="col-md-4 col-sm-12">
                                        <label class="form-label">{{ $t('products.attribut') }}</label>
                                        <div class="input-group input-group-solid flex-nowrap">
                                        <div class="overflow-hidden flex-grow-1">
                                            <select :data-key="key" data-dropdown-parent="#kt_modal_create_variation" class="form-select form-select-solid rounded-end-0 kt_select2"
                                                    data-control="select2" data-search="true" v-model="content.attribut_id"
                                                    name="attributs" :data-placeholder="$t('products.select_attribut')"
                                                    data-allow-clear="true">
                                                    <option v-for="attribut in getFilteredAttribute(key)" :key="attribut.id"
                                                    :value="attribut.id">{{ attribut.name }}
                                                    </option>
                                            </select>
                                        </div>
                                        <span @click="openVariationModal(true, key)"
                                                class="input-group-text">
                                                <span class="svg-icon svg-icon-2 px-1 py-3 text-center" :style="{'border': '1px solid '+$getCssVariable('--bs-primary'), 'border-radius': '5px', 'background-color': '#fff', 'width': '30px !important', 'height': '30px !important'}">
                                                    <i class="fas fa-plus text-primary" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                                </span>
                                        </span>
                                        </div>
                                    </div>

                                    <div class="col-md-7 col-sm-12">
                                        <label class="form-label"> {{ $t('products.variation') }}</label>
                                        <div class="input-group input-group-solid flex-nowrap">
                                        <div class="overflow-hidden flex-grow-1">
                                            <select :data-key="key" data-dropdown-parent="#kt_modal_create_variation" class="form-select form-select-solid kt_select2"
                                                    data-control="select2" multiple="multiple" name="variations[]" data-search="true" v-model="content.variations">
                                                    <option v-for="value in getAttributeVariations(content.attribut_id)" :key="value.id"
                                                    :value="value.id">{{ value.name }}
                                                    </option>
                                            </select>
                                        </div>
                                        <span @click.prevent="addVariationAttributeModalOpen(true, content.attribut_id, key)"
                                            v-if="content.attribut_id" class="input-group-text">
                                            <span class="svg-icon svg-icon-2 px-1 py-3 text-center" :style="{'border': '1px solid '+$getCssVariable('--bs-primary'), 'border-radius': '5px', 'background-color': '#fff', 'width': '30px !important', 'height': '30px !important'}">
                                                <i class="fas fa-plus text-primary" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                            </span>
                                        </span>
                                        </div>
                                    </div>
                                    <div class="col-md-1 col-sm-12" style="float: right;">
                                        <div class="card shadow-sm mt-8 py-2 px-4" style="height: 40px; width: 50px;">
                                            <div class="d-flex justify-content-center py-2 text-center" @click.prevent="drop(key)" style="border: 1px solid red; border-radius: 8px; background-color: #fff; width: 30px !important; height: 30px !important;">
                                                <i class="fa fa-trash-alt fs-2" style="color: red"></i>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="form-group mt-5 mb-5 text-end">
                                        <button @click.prevent="add" type="button" class="btn btn-sm btn-light-primary" style="border-radius: 5px">
                                            {{ $t('products.add_attribut') }}
                                            <span class="svg-icon svg-icon-2 p-1 text-center ms-1 bg-transparent" >
                                                <i class="fas fa-plus text-primary ms-1" :style="{'color': $getCssVariable(--bs-primary)}"></i>
                                            </span>
                                        </button>
                                    </div>
                                </div>

                                <div class="modal-footer">
                                    <Button btn-class="btn-sm me-2" type="cancel" size="7px 30px" btn-text="button.close" @click.prevent="openCreateVariationModal" :isLoading="loading"/>
                                    <Button btn-class="btn-sm" type="new" size="7px 30px" btn-text="button.save" @click.prevent="createProductVariationsData" :isLoading="loading"/>
                                </div>
                                </form>
                            </div>
                            </div>
                        </div>
                    </div>

                    <CategoryFormModal id="createCategoryModal" @after-create="addCategory"></CategoryFormModal>
                    <CreateBrand id="create" @add-brand="addBrand"></CreateBrand>
                    <CreateTax id="createTaxModal" @add-tax="addTax" :load="loadTaxes"></CreateTax>
                    <CreateVariationModal :attribut="{ attribut : formCreateValueData.id , value : []}" @add-attribut="addAttribut" :load="loadAttributs" id="create" parent="kt_modal_create_variation" :hasParent="hasParent"></CreateVariationModal>
                    <CreateVariationAttributeModal :attribut-value="{ attribut : formCreateValueData.id , value : []}"  @add-values="addValues" :load="loadVariations" id="add" parent="kt_modal_create_variation" :hasParent="hasParent"></CreateVariationAttributeModal>


                </div>
            </Loader>
        </template>
    </SubLayout>
</template>

<script>
    import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
    import { mapActions, mapGetters } from "vuex";
    import CategoryFormModal from "@/components/Category/CategoryFormModal";
    import CreateBrand from "@/components/Brand/CreateBrand";
    import CreateTax from "@/components/Tax/CreateTax";
    import CreateVariationModal from "@/components/Attribute/CreateAttribute";
    import CreateVariationAttributeModal from "@/components/Attribute/CreateAttributeValues.vue";
    import VueNumberFormat from 'vue-number-format'
    import ImageInput from "@/components/ImageInput.vue";
    import RequiredText from "@/components/RequiredText"
    import Loader from "@/components/Loader";
    import Button from "@/components/Button.vue"
    import {useSwal} from "@/composables/useSwal";
    import abilities from "@/composables/abilities";

    export default {
    components: {SubLayout, VueNumberFormat, CategoryFormModal, CreateVariationModal, CreateVariationAttributeModal, CreateBrand, ImageInput, RequiredText, Loader, CreateTax, Button},
    data() {
        const { showSwal } = useSwal();
        return {
            title: "breadcrumbs.products.title",
            product: {},
            formUpdateVariation: [],
            image: '',
            formCreateData: {
                reference: '',
                name: '',
                category: null,
                brand: null,
                type: null,
                description: null,
                expired_date: null,
                purchase_price: 0,
                selling_price: 0,
                image: null,
                online: true,
                barcode: '',
                attributs: [
                {
                    attribut_id: "",
                    variations: [],
                }
                ],
                taxes: []
            },
            formNewBrandData: {
                name: '',
            },
            formCreateValueData: {
                id: null
            },
            isReady: true,
            isLoading1: false,
            deletedProductSaleElements : [],
            hasParent: false,
            selectedKey: '',
            breadcrumbs: [
                {
                    name: 'breadcrumbs.products.list',
                    route: 'items',
                    params: {}
                },
                {
                    name: this.$route.query.product ? 'breadcrumbs.products.edit' : 'breadcrumbs.products.new',
                    route: 'items-details'
                }
            ],
            loading: false,
            deletedLoading: false,
            showSwal,
            abilities,
            initial_image: null
        }
    },

    computed: {
        ...mapGetters('company', ['getCompanyCurrency']),

        ...mapGetters('categories', ['getCategories']),

        ...mapGetters('brands', ['getBrands']),

        ...mapGetters('attributs', ['getAttributs']),

        ...mapGetters('variations', ['getVariations']),

        ...mapGetters('products', ['getTypes']),

      ...mapGetters('taxes', ['getTaxes']),


        attributsFormToString() {
        return JSON.stringify(this.formCreateData.attributs)
        },

        showMultipleDeleteBtn(){
        return this.deletedProductSaleElements.length > 0
        },

        isVariationProduct() {
        let sale_element_with_attributes = this.product.sale_element_with_attributes || []
        if (sale_element_with_attributes.length) {
            if (sale_element_with_attributes.length === 1) {
            let attributeAndCombination = sale_element_with_attributes[0].attributeAndCombination
            return !!attributeAndCombination.length;
            } else {
            return true
            }
        } else {
            return false
        }
        },

        getVariationsForSelectedAttribute() {
        let attributes = this.formCreateData.attributs.map(x => x.attribut_id)
        return this.getVariations.filter(variation => attributes.includes(variation.attribut_id))
        },

        getAttributsIds() {
        return this.formCreateData.attributs.map(x => x.attribut_id)
        }
    },

    watch: {
        formCreateData: function(value){
        if(value) {
            this.$nextTick(() => {
            this.initSelect2()
            })
        }
        },
        'getAttributsIds': function (newAttributes, oldAttributes) {
        let newAttributeSelected = newAttributes.filter(attribute => !oldAttributes.includes(attribute))
        let oldAttributeDeselected = oldAttributes.filter(attribute => !newAttributes.includes(attribute))
        this.formCreateData.attributs.map(data => {
            if (newAttributeSelected.includes(data.attribut_id)) {
            data.variations = []
            let newVariationsAttributeSelected = this.getVariationsForSelectedAttribute.filter(variation => data.attribut_id === variation.attribut_id)
            newVariationsAttributeSelected.forEach(variation => {
                data.variations.push(variation.id)
            })
            }

            if (oldAttributeDeselected.includes(data.attribut_id)) {
            data.variations = []
            data.attribut_id = null
            }
            return data
        })
        },
        attributsFormToString: function () {
        this.$nextTick(() => {
            this.initSelect2()
            this.handleCheckedVariations()
        })
        },
        'formCreateData.product': async function (value) {
        if (value) {
            await this.$router.replace({
            query: {
                product: value
            }
            })

            this.findProductById(value).then((response) => {
            this.product = response?.data?.product
            this.refreshProductData()
            this.initVariationForUpdating()
            this.$nextTick(() => {
                this.initSelect2()
                this.handleCheckedVariations()
            })
            })
        }
        },
        'product.sale_element_with_attributes':  function (value) {
        if (value) {
            this.initVariationForUpdating()
        }
        },
        'formCreateData.category': async function (value) {
        if (value) {
            this.$nextTick(() => {
            this.initSelect2()
            })
        }
        },
        'formCreateData.brand': async function (value) {
        if (value) {
            this.$nextTick(() => {
            this.initSelect2()
            })
        }
        },
        'formCreateData.type': async function (value) {
        if (value) {
          this.formCreateData.brand = null;
            this.$nextTick(() => {
            this.initSelect2()
            })
        }
        },
        'formCreateData.taxes': async function (value) {
            if (value) {
                this.$nextTick(() => {
                this.initSelect2()
                })
            }
        },
    },

    async mounted() {

        this.loadCategories()
        this.loadBrands()
        this.loadTypes()
        this.loadAttributs()
        this.loadVariations()
        this.loadTaxes()

        this.handleCheckedVariations()

        await this.generalInformation()

        this.isReady = false
        this.formCreateData.product = this.$route.query.product

        this.$nextTick(() => {
          this.initSelect2()
          KTImageInput.init()
        })


    },

    methods: {
        ...mapActions('categories', ['loadCategories']),
        ...mapActions('brands', ['loadBrands']),
        ...mapActions('attributs', ['loadAttributs',]),
        ...mapActions('variations', ['loadVariations']),
        ...mapActions('taxes', ['loadTaxes']),
        ...mapActions('products', [
        'createProduct',
        'createProductVariations',
        'findProductById',
        'uploadImage',
        'deleteProductSaleElement',
        'deleteProductSaleElements',
        'updateProductSaleElements',
        'loadTypes'
        ]),
        ...mapActions('brands', ['createBrand']),
        ...mapActions('company', ['generalInformation']),

        openCreateVariationModal() {
        $('#kt_modal_create_variation').modal('toggle')
        },

        addVariationAttributeModalOpen(parent, attribut_id, key) {
        this.selectedKey = key
        this.formCreateValueData.id = attribut_id
        this.hasParent = parent
        if(this.hasParent){
            $('#kt_modal_create_variation').modal('toggle')
        }
        $('#createAttributeValuesModal_add').modal('toggle')
        },

        openVariationModal(parent, key){
        this.selectedKey = key
        this.hasParent = parent
        if(this.hasParent){
            $('#kt_modal_create_variation').modal('toggle')
        }
        $('#createAttributeModal_create').modal('toggle')
        },

        initVariationForUpdating(){
        let data = []
        this.product.sale_element_with_attributes.map(saleElement => {
            data.push({
            'id': saleElement.id,
            'purchase_price': parseInt(saleElement.purchase_price),
            'selling_price': parseInt(saleElement.selling_price),
            'barcode': saleElement.barcode,
            })
        })

        this.formUpdateVariation = data
        },


        sortByKey(array, key) {
        return array.sort(function(a, b) {
            var x = a[key].toLowerCase();
            var y = b[key].toLowerCase();
            if (x < y) {
            return -1;
            }
            if (x > y) {
            return 1;
            }
            return 0;
        });
        },
        reloadProductData(){
        if(this.formCreateData.product){
            this.findProductById(this.formCreateData.product).then((response) => {
            this.product = response.data.product
            this.formCreateData.reference = response.data.product.reference
            this.formCreateData.name = response.data.product.name
            this.formCreateData.category = response.data.product.category_id
            this.formCreateData.type = response.data.product.type
            this.formCreateData.brand = response.data.product.brand_id
            this.formCreateData.description = response.data.product.description
            this.formCreateData.purchase_price = parseInt(response.data.product.purchase_price)
            this.formCreateData.selling_price = parseInt(response.data.product.selling_price)
            this.formCreateData.online = response.data.product.online
            this.formCreateData.image = response.data.product ? response.data.product.image_url : ''
            this.formCreateData.attributs = [{attribut_id: "", variations: []}]
            this.formCreateData.barcode = response.data.product ? response.data.product.barcode : ''
              this.formCreateData.taxes = response.data.product.taxes.map(tax => tax.id);

            })
            this.initial_image = response.data.product.image_url ?? null
        }
        },

        refreshProductData() {
            this.formCreateData.reference = this.product.reference
            this.formCreateData.name = this.product.name
            this.formCreateData.category = this.product.category_id
            this.formCreateData.type = this.product.type
            this.formCreateData.brand = this.product.brand_id
            this.formCreateData.description = this.product.description
            this.formCreateData.purchase_price = parseInt(this.product.purchase_price)
            this.formCreateData.selling_price = parseInt(this.product.selling_price)
            this.formCreateData.online = this.product.online
            this.formCreateData.image = this.product ? this.product.image_url : ''
            this.formCreateData.barcode = this.product ? this.product.barcode : ''
            this.formCreateData.taxes = this.product.taxes.map(tax => tax.id);

            this.initial_image = this.product.image_url ?? null
        },

        async createProductData() {
        this.formCreateData.attributs = this.formCreateData.attributs.filter((attribute) => attribute.attribut_id && attribute.attribut_id.length && attribute.variations.length)
        try {
            this.isLoading1 = true
            let response = await this.createProduct(this.formCreateData)

            let delete_image = this.initial_image && (this.formCreateData.image instanceof File || this.formCreateData.image == null) ? true : false
            let image = (this.formCreateData.image instanceof File) ? this.formCreateData.image : null
            
            let avatarData = new FormData()
            avatarData.append('image', image);
            avatarData.append('product_id', response.data.product.id);
            avatarData.append('delete_image', delete_image)
            await this.uploadImage(avatarData)

            window.toastr['success'](i18n.global.t("notification.product_created"))
            this.isLoading1 = false
            this.$router.push('/admin/items')
        } catch (e) {
            this.isLoading1 = false
        }
        },

        async createProductVariationsData() {
            this.loading = true
            this.formCreateData.attributs = this.formCreateData.attributs.filter((attribute) => attribute.attribut_id && attribute.attribut_id.length && attribute.variations.length)

            try {
            let response = await this.createProductVariations({attributs:this.formCreateData.attributs, product: this.formCreateData.product })

            window.toastr['success'](i18n.global.t("notification.product_variation_created"))

            this.formCreateData.product =  response.data.product.id
            this.reloadProductData()

            $('#kt_modal_create_variation').modal('toggle')

            } catch (e) {

            }finally {
            this.loading = false

            }
        },

        add() {
        this.formCreateData.attributs.push({
            attribut_id: null,
            variations: []
        })
        },

        drop(key) {
        if(this.formCreateData.attributs && this.formCreateData.attributs.length > 1){
            this.formCreateData.attributs.splice(key, 1);
        }
        },

        initSelect2() {

        KTApp.initSelect2()

          let select2 =  $(".kt_select2")

          select2.select2()

          select2.change((e) => {
            switch (e.target.name) {
            case 'category':
                this.formCreateData.category = e.target.value
                break;
            case 'brand':
                this.formCreateData.brand = e.target.value
                break;
            case 'type':
                this.formCreateData.type = e.target.value
                break;
            case 'online':
                this.formCreateData.online = JSON.parse(e.target.value)
                break;
            case 'attributs':
                this.formCreateData.attributs[e.target.getAttribute('data-key')].attribut_id = e.target.value
                break;
            case 'variations[]':
                let key = e.target.getAttribute('data-key')
                let result = [];
                for (var i = 0, iLen = e.target.selectedOptions.length; i < iLen; i++) {
                if (e.target.selectedOptions[i].value != '' || e.target.selectedOptions[i].value != undefined) {
                    result.push(e.target.selectedOptions[i].value);
                }
                }
                this.formCreateData.attributs[key].variations = result
                break;
              case 'taxes[]':
                let addTaxes = [];
                for (var k = 0, kLen = e.target.selectedOptions.length; k < kLen; k++) {
                  if (e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined) {
                    addTaxes.push(e.target.selectedOptions[k].value);
                  }
                }

                this.formCreateData.taxes = addTaxes
                break;
            default:
                break;
            }
        });

        },

        getAttributeVariations(attribut_id) {
        if (attribut_id) {
            return this.getVariationsForSelectedAttribute.filter(variation => variation.attribut_id == attribut_id)
        }
        return []
        },

        getFilteredAttribute(key) {
        let attributeBeforeKey = this.formCreateData.attributs
            .filter((data, i) => i < key)
            .map(data => data.attribut_id)

        return this.getAttributs.filter(attribut => !attributeBeforeKey.includes(attribut.id))
        },

        deleteProductSaleElementAction(productSaleElement, productId) {
            this.showSwal(
                i18n.global.t('swal.variation'),
                i18n.global.t('swal.text')
            )?.then( async (result) => {
                if (result.value) {
                    try {
                        await this.deleteProductSaleElement({
                            productSaleElement: productSaleElement,
                            productId: productId
                        })
                        window.toastr['success'](i18n.global.t("notification.product_deleted_variation"))
                        let productSaleElements = this.product.sale_element_with_attributes
                        productSaleElements = productSaleElements.filter(productSaleElmt => productSaleElmt.id !== productSaleElement)
                        this.product.sale_element_with_attributes = productSaleElements
                    } catch (e) {
                    }
                }
            })
        },

        deleteProductSaleElementsAction() {
            this.showSwal(
                i18n.global.t('swal.variation'),
                i18n.global.t('swal.text')
            )?.then( async (result) => {
                if (result.value) {
                    try {
                        this.deletedLoading = true
                        await this.deleteProductSaleElements({
                            data: this.deletedProductSaleElements,
                            productId: this.formCreateData.product
                        })
                        this.deletedProductSaleElements = []
                        let variation_checkbox = document.getElementsByName("variation_checkbox")
                        for(let i = 0; i < variation_checkbox.length; i++)
                        {
                            if(variation_checkbox[i].checked){
                                variation_checkbox[i].checked = !variation_checkbox[i].checked
                            }
                        }
                        this.reloadProductData()
                        window.toastr['success'](i18n.global.t("notification.product_deleted_variations"))
                        this.deletedLoading = false
                    } catch (e) {
                        this.deletedLoading = false
                    }
                }
            })
        },

        async addCategory(category) {
        this.formCreateData.category = category
        },

        async addBrand(brand) {
        this.formCreateData.brand = brand
        },

        async addTax(tax) {
            this.formCreateData.taxes.push(tax)
        },

        async addAttribut(attribut) {
        this.formCreateData.attributs[this.selectedKey].attribut_id = attribut
        },

        async addValues(value) {
        this.formCreateData.attributs[this.selectedKey].variations.push(value)
        },


        handleCheckedVariations(){
        $('#variation_all_checkbox').click(() => {
            if ($('#variation_all_checkbox').is(":checked")){
            this.deletedProductSaleElements = this.product.sale_element_with_attributes.map(saleElement => saleElement?.id)
            let variation_checkbox = document.getElementsByName("variation_checkbox")
            for(let i = 0; i < variation_checkbox.length; i++)
                variation_checkbox[i].checked = true;
            }else{
            this.deletedProductSaleElements = []
            let variation_checkbox = document.getElementsByName("variation_checkbox")
            for(let i = 0; i < variation_checkbox.length; i++)
                variation_checkbox[i].checked = false;
            }
        })

        $('.variation_checkbox').click(() => {
            let variation_checkbox = document.getElementsByName("variation_checkbox")
            let selectedVariation = []
            for(let i = 0; i < variation_checkbox.length; i++)
            {
            if(variation_checkbox[i].checked){
                selectedVariation.push(variation_checkbox[i].value)
            }
            }
            this.deletedProductSaleElements = selectedVariation
        })
        },

        async updateProductSaleElementsAction() {
        this.loading = true
        try {
            await this.updateProductSaleElements({productSaleElements: this.formUpdateVariation})
            window.toastr['success'](i18n.global.t("notification.save_variation"))
            this.reloadProductData()
        } catch (e) {

        } finally {
            this.loading = false
        }
        },
    }
    }
</script>

<style scoped>
.edit{
    left: 85%;
    top: 25px;
}
.remove {
    position: absolute;
    left: 80%;
    top: 70%;
}
.input-group-text {
    display: flex;
    align-items: center;
    padding: 0.25rem;
    font-size: 1.1rem;
    font-weight: 500;
    line-height: 1.5;
    color: var(--bs-secondary);
    text-align: center;
    white-space: nowrap;
    background-color: #f5f8fa;
    border: 1px solid #e4e6ef;
    border-radius: 0.475rem;
}
</style>